module.exports = __webpack_public_path__ + "img/citilink.a004caf9.svg";